import { FC } from "react";
import { Col, Row } from "react-bootstrap";
import { IoMdArrowRoundBack } from "react-icons/io";

type Props = {
  title?: string;
  description?: string;
};
export const ToolsHeader: FC<Props> = ({ title, description }) => {
  return (
    <Row>
      <Col style={{ paddingBottom: "20px" }}>
        <div
          style={{
            marginLeft: "1rem",
            color: "white",
            width: "2rem",
            height: "2rem",
            background: "#8CC540",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            marginBottom: "0.5rem",
          }}
          onClick={() => {
            window.location.href = `/`;
          }}
        >
          <IoMdArrowRoundBack size={20} />
        </div>
        <h1 style={{ textAlign: "center" }}>{title ?? ""}</h1>
        <div className="text-muted" style={{ textAlign: "center" }}>
          {description ?? ""}
        </div>
      </Col>
    </Row>
  );
};
